import React from "react";
import { Link, navigate } from "@reach/router";
import PropTypes from "prop-types";

// import config
import { LIVE_BRANCH_BASE as BRANCH_BASE } from "../../util/config";

// import assets
import othlLogo from "../../assets/othl/othl-logo-white.svg";

// import components
import BranchTiles from "../BranchTiles";
import Footer from "../Footer";

// import styled components
import {
  BranchContainerDivider,
  BranchContainerLogo,
  BranchContainerSkipLink,
  BranchListContainer,
  BranchListing,
  BranchNotFound,
} from "./styled";

function BranchContainer({
  branches,
  loading,
  notFound,
  location: { pathname },
}) {
  const checkIfValidPath = (path) => {
    const formattedPath = path.toLowerCase().replace(`${BRANCH_BASE}/`, "");

    let isValid = false;
    let branchPath = "";

    branches.map((branch) => {
      if (formattedPath === branch.path.toLowerCase()) {
        isValid = true;
        branchPath = branch.path;
      }
      return branch;
    });

    if (isValid) {
      navigate(`${BRANCH_BASE}/${branchPath}`);
    }

    return isValid;
  };

  if (notFound) {
    checkIfValidPath(pathname);
    return (
      <BranchListContainer>
        <BranchContainerSkipLink href="#main-content">
          Skip to Main Content
        </BranchContainerSkipLink>
        <BranchContainerLogo
          src={othlLogo}
          alt="OneTrust Home Loans"
          role="banner"
        />
        <BranchNotFound id="main-content" role="main">
          <BranchContainerDivider borderBottom="rgba(187, 187, 187)" />
          <h1>Not Found!</h1>
          <Link to={BRANCH_BASE}>
            Please click here to return to the branch home page.
          </Link>
        </BranchNotFound>
      </BranchListContainer>
    );
  }

  return (
    <BranchListContainer>
      <BranchContainerSkipLink href="#main-content">
        Skip to Main Content
      </BranchContainerSkipLink>
      <BranchContainerLogo
        src={othlLogo}
        alt="OneTrust Home Loans"
        role="banner"
      />
      <BranchListing id="main-content" role="main">
        <BranchContainerDivider borderBottom="rgba(187, 187, 187)" />
        <h1>Find Your Local Office</h1>

        <h1 className="text-3xl font-bold underline">Hello world!</h1>
        <BranchTiles
          branches={branches.filter((branch) => branch.id !== "0")}
          loading={loading}
        />
        <BranchContainerDivider borderBottom="rgba(187, 187, 187)" />
        <Footer />
      </BranchListing>
    </BranchListContainer>
  );
}

export default BranchContainer;

BranchContainer.propTypes = {
  branches: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  location: PropTypes.object.isRequired,
  notFound: PropTypes.bool.isRequired,
};

BranchContainer.defaultProps = {
  branches: [],
  location: {},
  notFound: false,
};
